<template>
    <div>
        <v-container>
            <div class="d-flex justify-space-between mt-10 mb-5">
                <h2 class="mb-3">Help Captions</h2>
                <v-btn class="mr-2 mt-1"
                       @click="onOpenHelpCreateModal">
                    <v-icon class="mr-1">mdi-help-box</v-icon> Create Help Caption
                </v-btn>

            </div>


            <v-text-field v-model="searchText"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          class="mb-3"
                          hide-details></v-text-field>

            <v-data-table :headers="headers"
                          :items="helpCaptions"
                          must-sort
                          :sort-by.sync="sortBy"
                          item-key="key"
                          :sort-desc.sync="sortDesc"
                          :server-items-length="totalItems"
                          :loading="isBusy"
                          :items-per-page.sync="pageSize"
                          :footer-props="{'items-per-page-options': [25, 50, 100, 100]}"
                          :page.sync="pageNo"
                          class="elevation-1">
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon v-bind="attrs"
                                   @click="onOpenHelpEditModal(item.name)"
                                   v-on="on" color="lighten-2">
                                <v-icon>mdi-clipboard-edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Update Help Caption</span>
                    </v-tooltip>

                </template>

                <template v-slot:item.dateRegistered="{ item }">
                    {{ item.dateRegistered | DateTime }}
                </template>

            </v-data-table>
        </v-container>



        <sweet-modal width="80%" :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" ref="createUpdateHelpModal" blocking>
            <v-form v-model="isFormValid" ref="helpForm">
                <v-container>
                    <h3 class="mb-3">
                        {{action}} Help Section
                    </h3>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="helpCaption.name"
                                          label="Name"
                                          single-line
                                          class="mb-3"
                                          hide-details></v-text-field>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <rich-text-editor @input="onUpdate" :value="helpCaption.htmlDescription" cancel-text="Cancel" valid-text="Validate" />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" align="right">
                            <v-btn v-if="action === 'Create'" @click="onCreateHelpCaption" class="mr-2 mt-1" color="primary">
                                {{action}}
                            </v-btn>
                            <v-btn v-if="action === 'Edit'" @click="onEditHelpCaption" class="mr-2 mt-1" color="primary">
                                {{action}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </sweet-modal>

    </div>
</template>
<script>
    import HelpCaptionService from "../../services/helpCaptionService"
    export default {
        name: 'HelpAdmin',
        components: {

        },
        data: function () {
            return {
                isBusy: true,
                helpCaptions: [],
                accessToken: "",
                searchText: "",
                action: "",
                searchTimer: null,
                pageNo: 1,
                pageSize: 10,
                totalItems: 0,
                sortBy: 'name',
                sortDesc: false,
                helpCaption: {
                    name: "",
                    htmlDescription: ""
                },
                headers: [
                    {
                        text: 'Name',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    { text: '', value: 'actions', align: 'end', sortable: false },
                ],
            }
        },
        watch: {
            pageNo: function () {
                this.searchHelpCaptions();
            },
            pageSize: function () {
                this.searchHelpCaptions();
            },
            searchText: function () {
                let self = this;
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(function () {
                    self.searchHelpCaptions();
                }, 1000);
            },
            sortBy: function () {
                this.searchHelpCaptions();
            },
            sortDesc: function () {
                this.searchHelpCaptions();
            }
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                //just some fixes to get around the rich content editor
                setTimeout(() => {
                    var footerButtons = document.getElementById("RTE__footer__actions");
                    if (footerButtons) {
                        footerButtons.style.display = "none";
                    }

                    var contentEditor = document.getElementById("RTE__edition__field");
                    if (contentEditor) {
                        contentEditor.style.textAlign = "left";
                    }
                }, 1000);

                await this.searchHelpCaptions();
              
            },
            onUpdate(text) {
                this.helpCaption.htmlDescription = text;
            },
            async searchHelpCaptions() {
                this.isBusy = true;
                var sortBy = this.sortBy ? "name" : this.sortBy;
                var sortDesc = this.sortDesc === false ? "ASCENDING" : "DESCENDING"
                const result = await HelpCaptionService.searchHelpCaptions(this.accessToken, this.searchText, this.pageNo, this.pageSize, sortBy, sortDesc);
                this.helpCaptions = result.data.map((item, key) => ({ ...item, key }));
                this.totalItems = result.count;
                this.isBusy = false;
            },
            onOpenHelpCreateModal() {
                this.action = "Create";

                this.helpCaption = {
                    name: "",
                    htmlDescription: ""
                };
                this.$refs.createUpdateHelpModal.open();
            },
            async onOpenHelpEditModal(name) {
                this.isBusy = true;
                this.action = "Edit";

                this.helpCaption = await HelpCaptionService.getHelpCaptionByName(name, this.accessToken);

                this.$refs.createUpdateHelpModal.open();
                this.isBusy = false;
            },
            async onCreateHelpCaption() {
                this.isBusy = true;

                await HelpCaptionService.createHelpCaption(this.helpCaption, this.accessToken);

                this.isBusy = false;

                await this.searchHelpCaptions();
                this.$refs.createUpdateHelpModal.close();
            },
            async onEditHelpCaption() {
                this.isBusy = true;

                await HelpCaptionService.updateHelpCaption(this.helpCaption, this.accessToken);

                this.isBusy = false;

                await this.searchHelpCaptions();
                this.$refs.createUpdateHelpModal.close();
            }
        },
        created() {
            this.setup();
        }
    }
</script>
